import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ChannelActivationForm from '../../../../forms/ChannelActivation/ChannelActivationForm';
import { CREATE_CHANNEL_ACTIVATION } from '../../../../redux/ChannelActivations';

const ChannelActivationModal = (props) => {
  const {
    isOpen, closeModal, createChannelActivation, channel, location: { pathname, },
  } = props;

  Modal.setAppElement('body');

  const handleSubmit = (values) => {
    createChannelActivation(`${pathname}/${channel.uniq_name}`, channel, values);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={modalStyles}
      contentLabel="Modal"
      className="make-photos"
    >
      <ChannelActivationForm
        onSubmit={handleSubmit}
      />
    </Modal>
  );
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    position: 'absolute',
    width: 'calc(100% - 40px)',
    maxWidth: '500px',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px',
  },
};

ChannelActivationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  channel: PropTypes.object.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  createChannelActivation: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  createChannelActivation: (redirectPath, channel, values) => {
    dispatch(CREATE_CHANNEL_ACTIVATION({ redirectPath, channelId: channel.id, channel_activation: values, }));
  },
});

const ChannelActivationModalWithRouter = withRouter(ChannelActivationModal);

export default connect(null, mapDispatchToProps)(ChannelActivationModalWithRouter);
